import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';

export interface LogoutDialogResult {
    confirmed: boolean;
    clearSelectedCeg: boolean;
}

@Component({
    selector: 'rendelo-logout-dialog',
    standalone: true,
    imports: [CommonModule, FormsModule, MatDialogModule, MatButtonModule, MatCheckboxModule],
    templateUrl: './logout-dialog.component.html'
})
export class LogoutDialogComponent {
    clearSelectedCeg = false;

    constructor(private dialogRef: MatDialogRef<LogoutDialogComponent, LogoutDialogResult>) {}

    onCancel(): void {
        this.dialogRef.close({ confirmed: false, clearSelectedCeg: false });
    }

    onConfirm(): void {
        this.dialogRef.close({ confirmed: true, clearSelectedCeg: this.clearSelectedCeg });
    }
}
